import { Link } from 'react-router-dom';
import type { PortfolioBacktestRefreshStatus } from '@einhaus/project314-types';
import { describePortfolioRefreshStatus } from './portfolioBacktestRefreshStatus';

export default function PortfolioBacktestRefreshSummary({
    backtestId,
    status
}: {
    backtestId: number;
    status: PortfolioBacktestRefreshStatus | undefined;
}) {
    return (
        <div className="space-y-1 whitespace-normal text-xs text-zinc-400">
            <div className={status?.isEnabled ? 'text-blue-300' : ''}>{describePortfolioRefreshStatus(status)}</div>
            {status && (
                <>
                    {backtestId !== status.baselineBacktestId && (
                        <Link
                            className="block text-blue-300 hover:underline"
                            to={`/user/portfolioBacktestStats?id=${status.baselineBacktestId}`}
                        >
                            Baseline #{status.baselineBacktestId}
                        </Link>
                    )}
                    <div>
                        Last refreshed: {status.lastSuccessfulRefreshDateTime ? `${status.lastSuccessfulRefreshDateTime} ET` : 'Not yet'}
                    </div>
                    <Link
                        className="block text-blue-300 hover:underline"
                        to={`/user/portfolioBacktestStats?id=${status.latestSuccessfulBacktestId}`}
                    >
                        Latest entries through {status.dataThroughDateTime.slice(0, 10)}
                    </Link>
                    {status.nextEligibleDateTime && (
                        <div title="Earliest scheduled weekend dispatch, subject to capacity. Manual requests may start earlier.">
                            Next eligible: {status.nextEligibleDateTime} ET
                        </div>
                    )}
                    {status.lastErrorMessage && (
                        <div className="text-amber-300" title={status.lastErrorMessage}>
                            Needs attention
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
